import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function ShowerGlass() {
  const points = ['Custom measured for your bathroom', 'Frameless, semi-frameless and sliding options', 'Multiple glass textures, designs, finishes and hardware choices', 'Designed for a cleaner, brighter, more open bathroom', 'Professional installation by experienced glass technicians'];
  return <section className="py-16 lg:py-24 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-197">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-198">
        <div className="order-2 lg:order-1 bg-slate-200 rounded-2xl aspect-video lg:aspect-square w-full flex items-center justify-center overflow-hidden relative" data-id="element-199">
          {/* Placeholder for actual image */}
          <div className="absolute inset-0 bg-gradient-to-tr from-glassBlue-100 to-slate-100 opacity-50" data-id="element-200"></div>
          <span className="text-slate-400 font-medium relative z-10" data-id="element-201">
            Shower Glass Imagery
          </span>
        </div>
        <div className="order-1 lg:order-2" data-id="element-202">
          <h2 className="text-3xl sm:text-4xl font-bold text-navy-900 tracking-tight mb-6" data-id="element-203">
            Custom Glass Shower Doors & Enclosures
          </h2>
          <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-204">
            Upgrade your bathroom with custom glass shower doors and enclosures
            designed to fit your space. Kosin’s Glass offers frameless,
            semi-frameless, sliding and Euro-style shower glass options with
            quality hardware and professional installation.
          </p>
          <ul className="space-y-4 mb-8" data-id="element-205">
            {points.map((point, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-206">
                <CheckCircle2 className="w-5 h-5 text-brandBlue-600 flex-shrink-0 mt-0.5" data-id="element-207" />
                <span className="text-slate-700 font-medium" data-id="element-208">{point}</span>
              </li>)}
          </ul>
          <a href="/glassshowerdoors.html" className="inline-flex items-center justify-center bg-white border-2 border-brandBlue-600 text-brandBlue-600 hover:bg-brandBlue-50 font-bold text-lg py-3 px-8 rounded-xl transition-colors" data-id="element-209">
            Explore Glass Shower Doors
          </a>
        </div>
      </div>
    </section>;
}